import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import Img, { ImgProps } from "@insite/mobius/Img";
import { LazyImageProps } from "@insite/mobius/LazyImage";
import {
    IS_CUSTOM_PRODUCT,
    IS_VARIANT_PRODUCT,
    PARENT_PRODUCT_THUMBNAIL
} from "@thkStore/Constants/ProductPropertiesKeys";
import React, { useState } from "react";
import { css } from "styled-components";

interface OwnProps {
    product: CartLineModel;
    extendedStyles?: ProductImageStyles;
}

type Props = OwnProps;

export interface ProductImageStyles {
    linkWrappingImage?: ClickablePresentationProps;
    /**
     * @deprecated Use img instead
     */
    image?: LazyImageProps;
    img?: ImgProps;
}

export const productImageStyles: ProductImageStyles = {
    linkWrappingImage: {
        css: css`
            width: 100%;
        `,
    },
    image: {
        css: css`
            img {
                height: 100%;
            }
        `,
    },
    img: {
        css: css`
            height: auto;
            width: 100%;
        `,
    },
};

const CartLineProductImage = ({ product, extendedStyles }: Props) => {
    const [styles] = useState(() => mergeToNew(productImageStyles, extendedStyles));

    let altText = product.altText;
    if (!altText || altText === "") {
        altText =  product.productName;
    }

    const isCustomProduct = product?.properties?.[IS_CUSTOM_PRODUCT] && JSON.parse(product.properties[IS_CUSTOM_PRODUCT].toLowerCase()) === true;
    const additionalProperties = {
        isVariantProduct: (product.properties[IS_VARIANT_PRODUCT] && product.properties[IS_VARIANT_PRODUCT] === "True"),        
        parentProductThumbnail: product.properties[PARENT_PRODUCT_THUMBNAIL],        
    };

    const imagePath = additionalProperties.isVariantProduct ? additionalProperties.parentProductThumbnail : product.smallImagePath;
    
    const loading = product.idx === undefined ? "lazy" : product.idx < 3 ? "eager" : "lazy";
    
    if (isCustomProduct) {
        return (
            <div>
                <Img {...styles.img} loading={loading} width="209" height="209" src={imagePath} altText={altText} />                
            </div>
        );
    }

    return (
        <Clickable
            {...styles.linkWrappingImage}
            href={product.productUri}            
            data-test-selector="productImage"
        >
            <div>
                <Img {...styles.img} loading={loading} width="209" height="209" src={imagePath} altText={altText} />                
            </div>            
        </Clickable>
    );
};

export default CartLineProductImage;
